<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">对账单</div>
      <div class="title--button"></div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="purchaseOrderSearch"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    >
    </my-operate>
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    ></myHtml>
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
    <!-- 详情 -->
    <myOrderDetails
      v-if="htmlDataDialogState.show2"
      :visible="htmlDataDialogState.show2"
      :homeIndex="18"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderDetails>
  </div>
</template>
<script>
import { selcetSetting, updateSetting, _debounce, customMenu } from "@/utils/myUtils";
import {
  pmgtPurchasesReceiptDoc_getCooperativeSupplierPurchaseStatementDocList,
  pmgtPurchasesReceiptDoc_getCooperativeSupplierPurchaseStatementDocView,
} from "@/api/myController/purchase";
export default {
  name: "reconciliation_bill",
  props: {},
  components: {},
  data() {
    return {
      homeKey: "xt_reconciliation_billOne",
      // 新增、详情、修改
      htmlDataDialogState: {
        show1: false,
        show2: false,
        show3: false,
      },
      routeType: 0,
      routeQuery: {},
      homeIndex: 0,
      // ------------------------------
      listQuery: {
        customerName: "", // 账户编号
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      // 操作栏数据
      operationTitleData: [],
      // 排序
      orderParam: {
        asc: false,
        dateAggregateBy: "",
        fieldName: "createTime",
      },
      // 操作栏数据
      titleOperationTitleData: [
        {
          name: "基本信息",
          value: "searchString",
          type: "text",
        },
        { name: "搜索", type: "button" },
      ],
      listLoading: false,
      columnType: "columnAll", // columnIndex序号,columnBox复选框
      // 按钮集合
      tableBtnList: ["详情"],
      // 表内容
      list: [],
      // 表头
      titleList: [
        {
          id: 11,
          name: "账单日期",
          value: "baseStatementDate",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: true,
          width: 100,
          sortable: true,
        },
        {
          id: 0,
          name: "账单编号",
          value: "purchasesStatementDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: true,
          width: 93,
          sortable: true,
        },
        {
          id: 1,
          name: "标题",
          value: "docName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: true,
          width: 220,
          sortable: true,
        },
        {
          id: 1,
          name: "全局搜索码",
          value: "globalSearchNumber",
          fixedState: false,
          isShow: true,
          color: "#1476c3",
          dataType: "text",
          canEdit: true,
          width: 120,
          sortable: true,
        },
        {
          id: 1,
          name: "供应商名称",
          value: "baseSupplierName",
          fixedState: false,
          isShow: true,
          dataType: "customTable",
          canEdit: true,
          width: 202,
        },
        {
          id: 2,
          name: "应付金额(折前)",
          value: "baseShouldPaymentAmount",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 110,
        },
        {
          id: 3,
          name: "应付金额(折后)",
          value: "baseShouldPaymentAmountDiscounted",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 113,
        },
        {
          id: 4,
          name: "折扣率(%)",
          value: "baseDiscount",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: true,
          width: 82,
        },
        {
          id: 5,
          name: "未付金额",
          value: "valueUnpaidAmount",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 74,
        },
        {
          id: 6,
          name: "已付金额",
          value: "valuePaidAmount",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 77,
        },
        {
          id: 7,
          name: "应开发票",
          value: "baseShouldInvoiceAmount",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 85,
        },
        {
          id: 8,
          name: "未开发票",
          value: "valueUninvoicedAmount",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 76,
        },
        {
          id: 10,
          name: "已开发票",
          value: "valueInvoicedAmount",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 80,
        },
        {
          id: 6,
          name: "请款金额",
          value: "valueRequestFundsAmount",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 77,
        },
        {
          id: 11,
          name: "预付款日期",
          value: "baseExpectedPaymentDate",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: true,
          width: 120,
        },
        {
          id: 55,
          name: "支付状态",
          value: "statusPayment",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "未支付",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
            },
            {
              label: "部分支付",
              value: 1,
              color: "white",
              backGroundColor: "rgb(169,209,142)",
            },
            {
              label: "完全支付",
              value: 2,
              color: "white",
              backGroundColor: "rgb(84,103,53)",
            },
            {
              label: "超量支付",
              value: 3,
              color: "white",
              backGroundColor: "rgb(56,87,35)",
            },
          ],
          canEdit: true,
          width: 120,
        },
        {
          id: 55,
          name: "账单状态",
          value: "statusDoc",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "进行中",
              value: 0,
              color: "white",
              backGroundColor: "rgb(79,129,246)",
            },
            {
              label: "已完成",
              value: 1,
              color: "white",
              backGroundColor: "rgb(79,129,246)",
            },
            {
              label: "已终止",
              value: 2,
              color: "white",
              backGroundColor: "rgb(79,129,246)",
            },
          ],
          canEdit: true,
          width: 115,
        },
        {
          id: 9,
          name: "审核状态",
          value: "statusCheck",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionKey: "",
          selectOptionList: [
            {
              label: "已审核",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58)",
              fontSize: "",
            },
            {
              label: "未审核",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230)",
              fontSize: "",
            },
          ],
          canEdit: true,
          width: 89,
        },
        {
          id: 12,
          name: "创建时间",
          value: "createTime",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 141,
        },
        {
          id: 13,
          name: "备注",
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: true,
          width: 150,
        },
      ],
    };
  },
  created() {
    this.$root.mainTitleList[this.homeKey] = JSON.parse(
      JSON.stringify(this.titleList)
    );
    this.getList();
    this.querySetting();
  },
  methods: {
    getList() {
      this.listLoading = true;
      this.list = [];
      pmgtPurchasesReceiptDoc_getCooperativeSupplierPurchaseStatementDocList({
        orderParam: [this.orderParam],
        filter: this.purchaseOrderSearch,
        modelType: 0,
        pageParam: this.listQuery,
      }).then((res) => {
        if (res.data.data.totalCount > 0) {
          res.data.data.dataList.forEach((item) => {
            try {
              for (let i = 1; i <= 50; i++) {
                // 详情
                let name1 = "detail_ext" + i;
                let name2 = "122-ext" + i;
                item[name2] = item[name1];
                // 订单
                let name3 = "main_ext" + i;
                let name4 = "121-ext" + i;
                item[name4] = item[name3];
                // 产品
                let name5 = "product_ext" + i;
                let name6 = "1-ext" + i;
                item[name6] = item[name5];
              }
            } catch (error) {}
            try {
              item.specifications = JSON.parse(item.baseMaterialSpecDesc);
            } catch (error) {
              item.specifications = [];
            }
            try {
              if (item.baseBomVersion) {
                item.baseBomVersionV2 = "V" + item.baseBomVersion;
              } else {
                item.baseBomVersionV2 = "---";
              }
            } catch (error) {}
          });
          this.list = res.data.data.dataList;
          this.listQuery.total = res.data.data.totalCount;
        } else {
          this.list = [];
        }
        this.listLoading = false;
        this.$refs.myOperate?.dragSortShow();
      });
    },
    async titleOperationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();
        default:
          break;
      }
    },
    // 操作栏点击事件
    operationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();
          break;
        default:
          break;
      }
    },
    // 点击按钮
    async btnClick(row, item, index, state) {
      switch (item) {
        case "详情":
          this.routeQuery = row;
          this.htmlDataDialogState.show2 = true;
          break;
        default:
          break;
      }
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        case "":
          break;

        default:
          break;
      }
    },
    // 多选
    selectChangeEvent(val) {
      this.changeList = val.records;
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records;
    },
    htmlDataDialogClose(state, data) {
      this.htmlDataDialogState.show1 = false;
      this.htmlDataDialogState.show2 = false;
      this.htmlDataDialogState.show3 = false;
      this.getList();
    },
    async querySetting() {
      let titleList = await selcetSetting(this.homeKey);
      if (titleList == null) {
        let listTwo = this.$root.mainTitleList[this.homeKey];
        let listThree = [];
        this.titleList = customMenu(listTwo, listTwo, listThree);
        updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
      } else {
        let listOne = titleList;
        let listTwo = this.$root.mainTitleList[this.homeKey];
        let listThree = [];
        this.titleList = customMenu(listOne, listTwo, listThree);
      }
      this.$refs.myOperate?.dragSortShow();
    },
    // 列宽拖动事件
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value == val.field && item.name == val.title) {
          item.width = val.renderWidth;
        }
      });
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
    },
    // 开始拖拽事件
    onStart(titleList) {},
    // 拖拽结束事件
    onEnd(titleList) {
      this.titleList = titleList;
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
    },
    // 复选框事件
    isShowClick(titleList) {
      this.titleList = titleList;
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
    },
    // 固定方向事件
    widthClick(titleList) {
      this.titleList = titleList;
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
    },
    // 重置
    async resetClick(titleList) {
      this.titleList = titleList;
      updateSetting(this, this.homeKey, JSON.stringify(this.titleList));
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
      justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.spanText {
  color: #1476c3;
  font-size: 14px;
}

.operations {
  float: left;
  width: 200px;
  padding-top: 6px;
}

/*  修改页面样式 */

.title--font {
  text-align: left;
  padding: 10px 0;
}
::v-deep .operation {
  margin-bottom: 10px;
}
::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}
::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}
::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}
::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
.title--button {
  right: 0;
  margin-top: 0.7%;
}
</style>
